'use client';

import { useSmoothAnchorScroll } from '@//hooks/useSmoothAnchorScroll';

/**
 * Client component that enables smooth scrolling for anchor links
 * Place this in your layout to enable smooth scrolling for all anchor navigation
 */
export const SmoothAnchorScroll = () => {
  useSmoothAnchorScroll();
  return null;
};
